import React from 'react';
import CreateCashDocument from './CreateCashDocument';

/**
 * Edit wrapper for CreateCashDocument (dual mode: create/edit)
 * Extracts id from URL and passes to CreateCashDocument
 */
const EditCashDocument: React.FC = () => {
  return <CreateCashDocument />;
};

export default EditCashDocument;
